import React, {Component} from 'react';
import TextField from '../lib/mdb/text-field';
import Selectize from '../lib/mdb/selectize';
import DateField from '../lib/mdb/date-field';
import TimeField from '../lib/mdb/time-field';
import _set from 'lodash/set';
import _get from 'lodash/get';

/**
 * Shows the receipt of the processed payment.
 * Expected properties:
 * onUpdateAgentCenter - function to call when updating agent center
 * - config
 * - data
 * - state
 */
class PaymentPreferenceSection extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {config, state, showDisasterRecovery} = this.props,
            {messages} = config,
            {data} = state,
            {disasterRecovery} = data;

        return (
            <div className={"opp-section"}>
                <h3 className="section-title">{messages["opp.paymentPreferences.title"]}</h3>
                <div className="row">
                    <div className="col-12">
                        <div className="card card-v2">
                            <div className="card-body">
                                {showDisasterRecovery && (
                                    <DisasterRecovery config={config} disasterRecovery={disasterRecovery}/>
                                )}
                                <FieldReceipt config={config} data={data}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

/**
 * Displays the components paid in a payment.
 * expected properties:
 * - payment
 */
class DisasterRecovery extends Component {
    constructor(props) {
        super(props);
        this.disasterRecoveryPostProcess = this.disasterRecoveryPostProcess.bind(this);
        this.serviceCenterPostProcess = this.serviceCenterPostProcess.bind(this);
    }

    /**
     * If disaster recovery is selected then make field receipt selected and not changeable.
     * @param name
     * @param value
     * @param data
     */
    disasterRecoveryPostProcess(name, value, data) {
        if (value === "1") {
            _set(data, 'fieldReceipt', '1');
        }
    }

    /**
     * trim leading zeros from service center number entered
     * @param name
     * @param value
     * @param data
     */
    serviceCenterPostProcess(name, value, data) {
        if (value) {
            value = value.replace(/^0+/, '');
            _set(data, 'serviceCenterNumber', value);
        }
    }

    render() {
        const {config, disasterRecovery} = this.props,
            {messages} = config,
            DisasterRecoveryOptionList = [
                {code: "0", description: messages["no.label"]},
                {code: "1", description: messages["yes.label"]}
            ],
            disasterList = DisasterRecoveryOptionList.map(item => ({
                code: item.code, description: item.description
            }));

        return (
            <div className="row mt-4">
                <div className="col-xs-12 col-md-6">
                    <div className="md-form form-group">
                        <Selectize
                            name="disasterRecovery"
                            description={messages["opp.paymentPreferences.disasterRecovery.label"]}
                            selectList={disasterList}
                            autoComplete="off"
                            validations={{
                                nonElectronicOnly: function (value, state) {
                                    const paymentMethod = _get(state, 'paymentMethod');
                                    // if payment method is last used pm then email is required
                                    if (paymentMethod && paymentMethod.paymentMethodCategory && paymentMethod.paymentMethodCategory !== "CASH") {
                                        if (value === "1") {
                                            return "Disaster recovery only permitted for Non-electronic payments";
                                        }
                                    }
                                    return '';
                                }
                            }}
                            postProcess={this.disasterRecoveryPostProcess}
                        >
                        </Selectize>
                    </div>
                </div>

                {disasterRecovery === "1" && (
                    <div id="service-center-container" className="col-xs-12 col-md-6">
                        <TextField
                            key="serviceCenterNumber"
                            name="serviceCenterNumber"
                            description={messages["opp.paymentPreferences.serviceCenter.label"]}
                            maxLength="7"
                            className="md-form form-group"
                            labelClass="active"
                            placeholder={messages["opp.paymentPreferences.serviceCenter.tip"]}
                            aria-required="true"
                            validations={{
                                required: messages["opp.validation.serviceCenterNumber.required"],
                                integer: "Please enter numeric Service Center"
                            }}
                            autoComplete="off"
                            postProcess={this.serviceCenterPostProcess}/>
                    </div>)
                }
            </div>
        );
    }
}

class AgentCenter extends Component {
    constructor(props) {
        super(props);
        this.updateServiceCenter = this.updateServiceCenter.bind(this);
    }

    updateServiceCenter(e) {
        const agentCenter =
            this.props.updateAgentCenter();
    }

    render() {
        const {config, state} = this.props,
            {agentCenter} = config;
        return (
            <div className="service-center-container">
                <div className="md-form form-group text-right m-0">
                    <React.Fragment>
                        <span className="display-label text-nowrap position-relative">{messages["opp.paymentPreferences.serviceCenter.label"]}</span>
                        <div className="w-100 mb-2"></div>
                        <span className="display-plaintext d-inline align-middle p-0">{agentCenter}</span>
                        <span className="d-inline">
                            {this.props.showUpdateAgentCenter && (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm waves-effect waves-light btn-validate-account m-0 ml-1 p-1"
                                    title={"Update"}
                                    onClick={this.updateServiceCenter}
                                >
                                    Update
                                </button>
                            )}
                        </span>
                    </React.Fragment>
                </div>
            </div>
        )
    }
}

class FieldReceipt extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {config, data} = this.props,
            {disasterRecovery, fieldReceipt} = data,
            {messages, agentCenter} = config,
            FieldReceiptOptionList = [
                {code: "0", description: messages["no.label"]},
                {code: "1", description: messages["yes.label"]}
            ],
            fieldList = FieldReceiptOptionList.map(item => ({
                code: item.code, description: item.description
            })),
            minFieldReceiptDate = (agentCenter === "777" || agentCenter === "890") ? -60 : JSON.parse(messages["opp.paymentPreferences.fieldReceiptDate.min"]);
        return (
            <div className="row mt-4">
                <div className="col-xs-12 col-md-6">
                    <div className="md-form form-group">
                        {disasterRecovery === "1" ?
                            <React.Fragment>
                                <span
                                    className="display-label">{messages["opp.paymentPreferences.fieldReceipt.label"]}</span>
                                <span className="display-plaintext">{messages["yes.label"]}</span>
                            </React.Fragment>
                            :
                            <Selectize
                                name="fieldReceipt"
                                description={messages["opp.paymentPreferences.fieldReceipt.label"]}
                                selectList={fieldList}
                                autoComplete="off"
                            >
                            </Selectize>
                        }
                    </div>
                </div>
                {fieldReceipt === "1" && (
                    <div className="col-xs-12 col-md-6">
                        <div id="field-receipt-container">
                            <div className="row">
                                <div className="col-12 col-md-4">
                                    <TextField
                                        key="fieldReceiptNumber"
                                        name="fieldReceiptNumber"
                                        description={messages["opp.paymentPreferences.fieldReceiptNumber.label"]}
                                        maxLength="8"
                                        className="md-form form-group"
                                        labelClass="active"
                                        placeholder={messages["opp.paymentPreferences.fieldReceiptNumber.tip"]}
                                        aria-required="true"
                                        validations={{
                                            required: messages["opp.validation.fieldReceiptNumber.required"]
                                        }}
                                        autoComplete="off"/>
                                </div>
                                <div className="col-12 col-md-4">
                                    <DateField name="fieldReceiptDate"
                                               className="md-form form-group"
                                               placeholder={messages["opp.date.tip"]} maxLength="12"
                                               description={messages["opp.paymentPreferences.fieldReceiptDate.label"]}
                                               autoComplete="off"
                                               min={minFieldReceiptDate}
                                               max={JSON.parse(messages["opp.paymentPreferences.fieldReceiptDate.max"])}
                                               aria-required="true"
                                               validations={{
                                                   required: messages["opp.validation.date.required"]
                                               }}
                                    />
                                </div>
                                <div className="col-12 col-md-4">
                                    <TimeField name="fieldReceiptTime"
                                               className="md-form form-group"
                                               placeholder={messages["opp.time.tip"]} maxLength="12"
                                               description={messages["opp.paymentPreferences.fieldReceiptTime.label"]}
                                               autoComplete="off"
                                               aria-required="true"
                                               validations={{
                                                   required: messages["opp.validation.time.required"]
                                               }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>)
                }
            </div>
        );
    }
}

export {
    PaymentPreferenceSection,
    AgentCenter
};